import React, { useRef,useState,useEffect  } from 'react';
import styles from './Naek30th.module.scss';
import { FaDownload } from 'react-icons/fa';
import common from '../../../common';

function Naek30th() {
    const { useAlert, useLoading, useConfirm, pToast } = common();
    const { pConfirm, ConfirmComponent } = useConfirm();




    const fesImgClick = (src) => {
        if (window.innerWidth <= 1000) {
            window.open(src, "_blank");
        } else {
            pConfirm(
                '',
                <>
                    <div className={`${styles.fes_img_confirm_wrap}`}>
                        <img src={src} alt="" className={`${styles.fes_img_confirm_img}`} />
                    </div>
                </>,
                'auto',
                'auto',
                '',
                '',//확인버튼 텍스트
                '닫기',//취소버튼 텍스트
                '',//제목 클래스명
                'fes_img_confirm_con',//콘텐츠 클래스명
                'fes_img_confirm_btn_box',//모달 컨텐츠 클래스명
            );
        }
    };
    
    return (
    <>
            <ConfirmComponent />
            <div className={`${styles.top_blue_box}`}>
                <div className={`${styles.top_blue_box_inner}`}>
                    <img className={`${styles.n30t_top_em}`} src="/img/naek30th/n30t_top_em.png?v1" alt="" />
                    <img className={`${styles.n30t_top_txt}`} src="/img/naek30th/n30t_top_txt.png?v1" alt="" />
                </div>
            </div>
            <div className={`components_wrap ${styles.components_wrap_naek30th}`}>
                <div className="cont_wrap">
                    <div className="cont_box" style={{paddingLeft:0}}>
                        <p className={`${styles.s1_txt_fir}`}>1995년, 우리 사회의 지속가능한 발전과 국가 경쟁력 강화를 위해 공학인 중심의 독립적이고 전문적인 기구로 출범한 한국공학한림원은, 지난 30년간 대한민국 공학기술의 미래를 이끌어온 선도기관으로서 자리매김해왔습니다.</p>
                        <p>그동안 한국공학한림원은 국내 최고의 공학기술 석학과 산업계를 대표하는 리더들이 모여 공학기술의 발전과 확산, 인재양성, 정책 자문, 그리고 국제협력 등 다양한 분야에서 의미 있는 성과를 이뤄냈습니다. 특히, 급변하는 기술 환경 속에서 지속가능한 사회를 위한 해법을 모색하고, 공학기술이 국민 삶의 질 향상에 기여할 수 있도록 다각적인 노력을 이어왔습니다.</p>
                        <p>창립 30주년은 그간의 발자취를 돌아보고, 다가올 미래를 준비하는 새로운 출발점입니다. 공학기술이 국가 발전의 핵심 동력으로 더욱 주목받고 있는 지금, 한국공학한림원은 기술과 사회, 사람을 잇는 가교로서의 역할을 더욱 충실히 수행해 나갈 것입니다.</p>
                        <p>다가올 30년, 한국공학한림원은 공학기술의 비전과 가치를 우리 사회와 공유하며, 더 나은 세상을 향한 기술의 길을 함께 열어가겠습니다.</p>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>창립30주년기념 엠블럼 및 슬로건</span>
                    </div>
                    <div className="cont_box">
                        <div className="cont_wrap2">
                            <div className="cont_tit_box_mini">
                                <span>엠블럼</span>
                            </div>
                            <div className="cont_box">
                                <div className={`${styles.logo_img_box} cont_img_box`}>
                                    <img src="/img/30주년_엠블럼_메인.jpg" className='' alt="" style={{}} />
                                    <img src="/img/30주년_엠블럼_체크배경.png" className='' alt="" style={{}} />
                                </div>
                                <p>한국공학한림원의 30주년을 상징하는 엠블럼은 숫자 30을 형상화하였습니다. </p>
                                <p>NAEK 로고 컬러인 블루를 메인으로 하고, 여기에 메탈릭한 느낌을 주기 위해 그라데이션 처리를 하였습니다.</p>
                                <p>‘3’과 연결되는 ‘0’, 또 그 안의 선들은 공학의 여러 분야가 서로 연결되어 시너지를 창출한다는 의미와 미래지향적 가치를 담고 있습니다.</p>
                                <p>회로 패턴과 육각형의 모습도 공학의 특성을 나타내며, 또한 NAEK 로고와 함께 시작 연도를 넣어 한국공학한림원의 역사를 반영했습니다. </p>
                            </div>
                        </div>
                        <div className="cont_wrap2">
                            <div className="cont_tit_box_mini">
                                <span>슬로건</span>
                            </div>
                            <div className="cont_box">
                                <div className={`${styles.logo_img_box} cont_img_box`}>
                                    <img src="/img/슬로건_메인.jpg" className='' alt="" style={{}} />
                                    <img src="/img/슬로건_메인_체크배경.png" className='' alt="" style={{}} />
                                </div>
                                <p>한국공학한림원 30주년 기념 슬로건은 ‘혁신을 주도하며, 미래를 변화시켜 가겠다’는 의지를 담고 있습니다. 이 의미를 담아 워드마크는 영문과 국문을 조합하여 디자인하였습니다.</p>
                                <p>‘INNOVATE’는 이중 라인으로 현대적인 감각으로 공학 기술의 정교함을 담았으며, ‘Tomorrow’는 엠블럼 컬러에 맞춰 메탈릭한 느낌을 더해 통일감을 주었습니다.</p>
                                <p>영문 워드마크가 메인이며, 필요에 따라 국문은 제외하고 영문만 사용 가능합니다. 하지만 국문만 단독으로 사용할 수는 없습니다.</p>
                            </div>
                        </div>
                        <div className={`${styles.ci_btn_wrap}`}>
                            <div className={`${styles.ci_btn_box}`}>
                                <a href="/img/한국공학한림원_30주년_BI_매뉴얼.pdf" download className={`p_btn p_btn_normal`}>
                                    <span>매뉴얼 다운로드</span>
                                    <FaDownload className={`${styles.ci_icon}`} />
                                </a>
                            </div>
                            <div className={`${styles.ci_btn_box}`}>
                                <a href="/img/30주년_CI.zip" download className={`p_btn p_btn_normal`}>
                                    <span>CI 파일 다운로드</span>
                                    <FaDownload className={`${styles.ci_icon}`} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>창립30주년기념식</span>
                    </div>
                    <div className="cont_box">
                        <ul className={`${styles.bul_list_2}`}>
                            <li>일시: 2025년 10월 29일(수) 14:00</li>
                            <li>장소: 인터콘티넨탈 서울 코엑스(서울시 강남구 테헤란로 521)</li>
                            <li>프로그램</li>
                        </ul>
                        <div className="cont_wrap3">
                            <div className="cont_tit_box_mini">
                                <span>Ⅰ. 30주년 기념식</span>
                            </div>
                            <div className={`${styles.program_tbl_box}`}>
                                <table>
                                    <colgroup>
                                        <col className={`${styles.p_tbl_col_date}`} />
                                        <col className={`${styles.p_tbl_col_du}`} />
                                        <col className={`${styles.p_tbl_col_con1}`} />
                                        <col className={`${styles.p_tbl_col_auto}`} />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>시 간</th>
                                            <th colSpan={2}>내 용</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='tac'>13:30~14:00</td>
                                            <td className='tac'>(30′)</td>
                                            <td colSpan={2}>리셉션</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:00~14:01</td>
                                            <td className='tac'>(1′)</td>
                                            <td className='tac' rowSpan={5}>기념식</td>
                                            <td>·&nbsp;&nbsp;&nbsp;오프닝영상</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:01~14:05</td>
                                            <td className='tac'>(4′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;개회</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:05~14:10</td>
                                            <td className='tac'>(5′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;환영사</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:10~14:15</td>
                                            <td className='tac'>(5′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;축사</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:15~14:25</td>
                                            <td className='tac'>(10′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;창립 30주년 기념 영상<br />&nbsp;&nbsp;1) 축하 영상<br />&nbsp;&nbsp;2) 기념 영상</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:25~14:30</td>
                                            <td className='tac'>(5′)</td>
                                            <td colSpan={2}>창립 30년사 발간식</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:30~14:35</td>
                                            <td className='tac'>(5′)</td>
                                            <td className='tac' rowSpan={2}>수여식</td>
                                            <td>·&nbsp;&nbsp;&nbsp;공로상 수여식</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:35~14:40</td>
                                            <td className='tac'>(5′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;기부자 현판 수여식</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:40~14:43</td>
                                            <td className='tac'>(3′)</td>
                                            <td colSpan={2}>비전 선포식</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:43~14:48</td>
                                            <td className='tac'>(5′)</td>
                                            <td colSpan={2}>기념촬영</td>
                                        </tr>

                                        <tr>
                                            <td className='tac'>14:48~14:50</td>
                                            <td className='tac'>(2′)</td>
                                            <td colSpan={2}>폐회</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={4}>Break Time Ⅰ (14:50~15:00)</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        
                        <div className="cont_wrap3">
                            <div className="cont_tit_box_mini">
                                <span>Ⅱ. NAEK Members Program</span>
                            </div>
                            <div className={`${styles.program_tbl_box}`}>
                                <table>
                                    <colgroup>
                                        <col className={`${styles.p_tbl_col_date}`} />
                                        <col className={`${styles.p_tbl_col_du}`} />
                                        <col className={`${styles.p_tbl_col_auto}`} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <td className='tac'>15:00~15:02</td>
                                            <td className='tac'>(2′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;개회</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>15:02~15:58</td>
                                            <td className='tac'>(56′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;NAEK Members Program</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>15:58~16:00</td>
                                            <td className='tac'>(2′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;폐회</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={3}>Break Time Ⅱ (16:00~16:30)</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        
                        <div className="cont_wrap3">
                            <div className="cont_tit_box_mini">
                                <span>Ⅲ. NAEK Family Program</span>
                            </div>
                            <div className={`${styles.program_tbl_box}`}>
                                <table>
                                    <colgroup>
                                        <col className={`${styles.p_tbl_col_date}`} />
                                        <col className={`${styles.p_tbl_col_du}`} />
                                        <col className={`${styles.p_tbl_col_auto}`} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <td className='tac'>16:30~16:32</td>
                                            <td className='tac'>(2′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;개회</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>16:32~16:37</td>
                                            <td className='tac'>(5′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;오프닝 공연</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>16:37~18:00</td>
                                            <td className='tac'>(83‘)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;NAEK Got Talent<br />·&nbsp;&nbsp;&nbsp;NAEK 퀴즈쇼</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>18:00~19:00</td>
                                            <td className='tac'>(60′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;만찬 </td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>19:00~19:10</td>
                                            <td className='tac'>(10′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;경품추첨</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>19:10~19:30</td>
                                            <td className='tac'>(20′)</td>
                                            <td>·&nbsp;&nbsp;&nbsp;클로징 공연</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className='tac'>19:30~</td>
                                            <td className='tac'></td>
                                            <td>·&nbsp;&nbsp;&nbsp;폐회</td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

  
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>공학한림원의 새로운 정체성 확립</span>
                    </div>
                    <div className="cont_box">
                        <p>창립 30주년을 맞은 한국공학한림원이 과거의 성과를 넘어 다음 30년을 설계하기 위해 공학한림원만의 새로운 정체성을 재정립합니다.</p>
                        <p>공학기술 분야의 전문가 집단으로서 기관의 정체성과 방향성을 명확히 하고 지속가능한 미래를 선도하기 위한 브랜드 아이덴티티 체계를 수립합니다.</p>
                        <p>새로워진 기관과 회원의 정체성, 비전, 미션, 가치 등을 소개합니다.</p>
                        <p className={`${styles.highlight1}`}>공학한림원의 새로운 비전과 정체성<br />2025년 9월 오픈 예정</p>
                    </div>
                </div>


                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>한국공학한림원 30년사 발간</span>
                    </div>
                    <div className="cont_box">
                        <img className={`${styles.n30t_pub}`} src="/img/naek30th/n30t_pub.png?v1" alt="" />
                        <p>한국공학한림원은 창립30주년을 맞아 지난 세대의 발자취를 되돌아보고 미래를 조망하기 위해 「한국공학한림원 30년사」를 발간합니다. 30년사는 단순한 연대기적 기록을 넘어, 지난 30년 동안 우리나라 공학 분야가 어떻게 도전과 혁신을 거듭해 왔는지, 그리고 그 과정에서 한국공학한림원이 어떤 역할을 수행했는지를 심도 있게 담아내고자 기획되었습니다.</p>
                        <p>1995년 설립 이래로 국내외 공학계의 패러다임을 바꾸어 온 주요 사건과 의사결정 과정을 연대별로 정리하여, 공학한림원의 설립 목표와 비전이 어떻게 현실화되었는지 한눈에 확인할 수 있도록 하였습니다. 또한 정책제언, 국제협력, 인재 양성 등 각 분야에서 축적된 성과를 다채로운 인터뷰와 자료로 보강하여, 단순 나열이 아닌 생생한 현장의 목소리를 함께 전합니다.</p>
                        <p>또한 이번 30년사는 미래 지향적 통찰을 제공합니다. 30년의 경험을 바탕으로 지금 우리 사회가 직면한 공학·기술적 과제를 분석하고, 앞으로 30년을 준비하기 위해 회원이 제안하는 비전을 담았습니다. 이번 발간 사업은 지난 30년의 성취를 기념함과 동시에 새로운 출발점이 되고자 합니다. 홈페이지를 통해 주요 목차와 하이라이트를 확인하시고, 디지털 열람 및 다운로드 서비스와 함께 다양한 온·오프라인 기념 행사에도 많은 관심과 참여를 부탁드립니다. 미래 30년을 함께 그려 나갈 여러분의 목소리를 기다립니다.</p>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>미래 30년을 위한 기부금 모집</span>
                    </div>
                    <div className="cont_box" style={{ position: "relative" }}>
                        <div className={styles.n30th_bg}></div>
                        <div className={styles.n30th_top_box}>
                            <span className={styles.n30th_t_left_txt}></span>
                            <span className={styles.n30th_t_right_sb}></span>
                        </div>
                        <div className={styles.n30th_middle_txt}></div>
                        <div className={styles.n30th_bottom_box}>
                            <span>올해로 30번째 생일을 맞은 한국공학한림원은<br />
                            지난 30년간 공학한림원이 걸어온 발자취를 기념하고,<br />
                            향후 30년을 향해 나아가기 위한 기부금을 모집합니다.<br />
                            회원 여러분의 많은 참여를 부탁드립니다.</span>
                        </div>
                        <div className='flex_center '>
                            <button
                                className="p_btn p_btn_normal"
                                onClick={() => window.open('https://secure.donus.org/naek30th/', '_blank')}
                                >온라인 기부 바로가기</button>
                        </div>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>창립30주년 특별 프로그램: NAEK Young Festival</span>
                    </div>
                    <div className="cont_box">
                        <p>미래 공학인재 양성을 위한 참여형 프로그램이 지난 7월 11일(금) 삼성동 코엑스 컨퍼런스룸에서 개최되었습니다.</p>
                        <div className="cont_wrap2">
                            <div className="cont_tit_box_mini">
                                <span>1일차(7/11)</span>
                            </div>
                            <div className="cont_box">
                                <ul className={`${styles.bul_list_2}`}>
                                    <li>오전 프로그램: NAEK Guru Mentoring</li>
                                    <li>주제 : 공학계 대학생 멘티와 공학한림원 전문분야 석학이 만나는 성장 멘토링</li>
                                </ul>
                                <div className="cont_wrap3">
                                    <div className={`${styles.y_f_tit}`}>
                                        <span>멘토단 명단</span>
                                        <span className={`${styles.y_f_tit_r}`}>(가나다 순)</span>
                                    </div>
                                    <div className={`${styles.program_tbl_box} ${styles.program_tbl_box2}`}>
                                        <table>
                                            <colgroup>
                                                <col className={`${styles.p_tbl_col_num}`} />
                                                <col className={`${styles.p_tbl_col_name}`} />
                                                <col className={`${styles.p_tbl_col_auto}`} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>성 명</th>
                                                    <th>소속 및 직함</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='tac'>1</td>
                                                    <td className='tac'>류수정</td>
                                                    <td className='tac'>서울대학교 교수/前 사피온 대표 </td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>2</td>
                                                    <td className='tac'>류승호</td>
                                                    <td className='tac'>㈜이수스페셜티케미컬 사장</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>3</td>
                                                    <td className='tac'>박용인</td>
                                                    <td className='tac'>삼성전자 System LSI사업부 사장 </td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>4</td>
                                                    <td className='tac'>배현섭</td>
                                                    <td className='tac'>슈어소프트테크(주) 대표이사</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>5</td>
                                                    <td className='tac'>오세현</td>
                                                    <td className='tac'>서울대학교 객원교수/前 SK텔레콤 부사장</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>6</td>
                                                    <td className='tac'>윤의준</td>
                                                    <td className='tac'>한국공학한림원 회장</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>7</td>
                                                    <td className='tac'>전혜정</td>
                                                    <td className='tac'>LG전자 인공지능연구소 연구위원 </td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>8</td>
                                                    <td className='tac'>조혜정</td>
                                                    <td className='tac'>삼성물산 건설부문 DxP 부사장 </td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>9</td>
                                                    <td className='tac'>차기철</td>
                                                    <td className='tac'>㈜인바디 대표이사 회장  </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{height:'15px'}}></div>
                                    <img className={`${styles.fes_img}`} src="/img/naek30th/m1.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }} />
                                    <div>
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/m2.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/m3.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                    </div>
                                </div>
                            </div>
                            
                            <div className={`${styles.fes_line}`}></div>

                            <div className="cont_box">
                                <ul className={`${styles.bul_list_2}`}>
                                    <li>오후 프로그램: NAEK Young Leaders Forum (영리더스포럼)</li>
                                    <li>연사</li>
                                </ul>
                                <div className="cont_wrap3">
                                    <div className={`${styles.y_f_tit}`}>
                                        <span>연사 명단</span>
                                    </div>
                                    <div className={`${styles.program_tbl_box} ${styles.program_tbl_box2}`}>
                                        <table>
                                            <colgroup>
                                                <col className={`${styles.p_tbl_col_name2}`} />
                                                <col className={`${styles.p_tbl_col_auto}`} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>연사</th>
                                                    <th>주제</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='tac'>신정규 래블업 대표</td>
                                                    <td className='tac'>AI 시대의 과학공학인</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>이세영 뤼튼테크놀로지스 대표</td>
                                                    <td className='tac'>Dare to Lead in the Unknown</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className='tac'>박지은 펄스나인 대표</td>
                                                    <td className='tac'>AI와 콘텐츠 산업의 경계에서 – 창업과 생존, 커리어</td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{height:'15px'}}></div>
                                    <div>
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/y1.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/y2.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/y3.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/y4.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/y5.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/y6.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.fes_line2}`}></div>
                        <div className="cont_wrap2">
                            <div className="cont_tit_box_mini">
                                <span>2일차(7/12)</span>
                            </div>
                            <div className="cont_box">
                                <ul className={`${styles.bul_list_2}`}>
                                    <li>오후 프로그램: NAEK-Pic(주니어 공학 올림픽)</li>
                                    <li>초등학생 100명과 임직원 30명이 참여한 창의·참여형 공학 챌린지로 아이디어톤, 과학살롱, 공학 메이킹, 아이디어 보드 제작과 전시 진행</li>
                                </ul>
                                
                                <div className="cont_wrap3">
                                    <img className={`${styles.fes_img}`} src="/img/naek30th/n1.jpg" alt="" />
                                    <div>
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n2.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n3.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n4.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n5.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n6.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n7.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n8.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />
                                        <img className={`${styles.fes_img} ${styles.fes_img_h}`} src="/img/naek30th/n9.jpg" alt="" onClick={(e) => { const imgSrc = e.target.src; fesImgClick(imgSrc); }}  />

                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Naek30th;